// see AssignmentSummary#renderDocumentHistory
export const determineDocType = (documentTypeId) => {
// these are only the ones that appraiser should see, not the full list
  switch (documentTypeId) {
    case '1': return 'Appraisal Report'
    case '2': return 'Sales Contract'
    case '7': return 'Repair Inspection Report'
    case '9': return 'Post Construction Inspection Report'
    case '10': return 'Other'
    case '600': return 'Construction Exhibits'
    case '900': return 'NOV'
    default: return ''
  }
}

// see AssignmentSummary#handleFileUpload
// valid types: .pdf, .doc, .docx, .xlsx, .xls, .tif, .tiff, .gif, .jpg, .jpeg, .png
export const validFileType = (type) => {
  switch (type) {
    case 'application/pdf': return true
    case 'application/msword': return true
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return true
    case 'application/vnd.ms-excel': return true
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return true
    case 'image/tiff': return true
    case 'image/gif': return true
    case 'image/jpeg': return true
    case 'image/png': return true
    default: return false
  }
}

// see AssignmentOverviewPage
export const determineStatus = (dispositionCode) => {
  switch (dispositionCode) {
    case 'B': return 'Appraisal Request Received'
    case 'C': return 'Request Canceled by VA'
    case 'I': return 'CRV/NOV/MCRV Issued'
    case 'O': return 'Out for Appraisal'
    case 'P': return 'Appraisal Pending Review'
    case 'Q': return 'Case Initiated'
    case 'R': return 'Property Rejected'
    case 'S': return 'Suspended for Additional Information'
    case 'W': return 'Request Withdrawn by Requester'
    default: return ''
  }
}

// see AssignmentOverviewPage
export const determineType = ({ appraisalCode, nadlAppraisalIndicator, refinanceAmount, salePrice, exteriorOnlyAppraisalReport }) => {
  if (appraisalCode === 'LAPP' || appraisalCode === 'IND') {
    if (salePrice !== null) {
      if (appraisalCode === 'LAPP') {
        return 'LAPP-Origination'
      } else if (appraisalCode === 'IND' && nadlAppraisalIndicator !== null) {
        return 'IND-NADL Origination'
      } else if (appraisalCode === 'IND') {
        return 'IND-Origination'
      }
    } else if (refinanceAmount !== null) {
      if (appraisalCode === 'LAPP') {
        return 'LAPP-Refinance'
      } else if (appraisalCode === 'IND' && nadlAppraisalIndicator !== null) {
        return 'IND-NADL Refinance'
      } else if (appraisalCode === 'IND') {
        return 'IND-Refinance'
      }
    } else {
      if (appraisalCode === 'LAPP') {
        return 'LAPP'
      } else {
        return 'IND-NADL'
      }
    }
  } else if (appraisalCode === 'MBL') {
    return 'MBL-Origination'
  } else if (appraisalCode === 'SAPP' || appraisalCode === 'LGI' || appraisalCode === 'LPL') {
    return `${appraisalCode}-Liquidation`
  } else {
    return appraisalCode
  }
}

export const formatPhone = (string) =>
  string ? string.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : ''

export const formatDollars = (string) =>
  string ? parseFloat(string).toFixed(2).replace(/(\d{1,2})(?=(\d{3})+\.)/g, '$1,') : ''
